<template>
  <div class="hi-lo-statistics">
    <div class="stats" style=" height:150px;">
      <!-- TODO: STATISTIC ERROR -->
      <span v-for="(i, card) in stat.totalCard">
        <Progress
          v-if="card != 'Joker' && card != 'K' &&  card != 'A' && card != 'highestCard' && i != 0"
          vertical
          :percent="i * (95 / stat.totalCard['highestCard'])"
          stroke-color="#00CED1"
        >
          <span>{{ card }}</span>
          <span
            class="index"
            :style="{
              top: 100 - i * (95 / stat.totalCard['highestCard']) + '%'
            }"
          >{{ i }}</span>
        </Progress>
        <Progress
          v-if="card != 'Joker'  && card != 'K' &&  card != 'A' && card != 'highestCard' && i == 0"
          vertical
          :percent="1"
          stroke-color="#00CED1"
        >
          <span>{{ card }}</span>
          <span class="index" :style="{ top: 82 + '%', color: '#000000' }">0</span>
        </Progress>
      </span>
      <span v-for="(i, card) in stat.totalCard">
        <Progress
          v-if="card == 'K' && card != 'highestCard' && i != 0"
          vertical
          :percent="i * (95 / stat.totalCard['highestCard'])"
          stroke-color="#00CED1"
        >
          <span>{{ card }}</span>
          <span
            class="index"
            :style="{
              top: 100 - i * (95 / stat.totalCard['highestCard']) + '%'
            }"
          >{{ i }}</span>
        </Progress>

        <Progress
          v-if="card == 'K' && card != 'highestCard' && i == 0"
          vertical
          :percent="1"
          stroke-color="#00CED1"
        >
          <span>{{ card }}</span>
          <span class="index" :style="{ top: 82 + '%', color: '#000000' }">0</span>
        </Progress>
      </span>
      <span v-for="(i, card) in stat.totalCard">
        <Progress
          v-if="card == 'A' && card != 'highestCard' && i != 0"
          vertical
          :percent="i * (95 / stat.totalCard['highestCard'])"
          stroke-color="#00CED1"
        >
          <span>{{ card }}</span>
          <span
            class="index"
            :style="{
              top: 100 - i * (95 / stat.totalCard['highestCard']) + '%'
            }"
          >{{ i }}</span>
        </Progress>

        <Progress
          v-if="card == 'A' && card != 'highestCard' && i == 0"
          vertical
          :percent="1"
          stroke-color="#00CED1"
        >
          <span>{{ card }}</span>
          <span class="index" :style="{ top: 82 + '%', color: '#000000' }">0</span>
        </Progress>
      </span>
      <!-- <span v-for="(i, card) in stat.totalCard">
      
      </span>-->
      <span v-for="(i, card) in stat.totalCard">
        <Progress
          v-if="card == 'Joker' && i != 0"
          vertical
          :percent="i * (95 / stat.totalCard['highestCard'])"
        >
          <span>JK</span>
          <span
            class="index"
            :style="{
              top: 100 - i * (95 / stat.totalCard['highestCard']) + '%'
            }"
          >{{ i }}</span>
        </Progress>
      </span>
      <span v-for="(i, card) in stat.totalCard">
        <Progress v-if="card == 'Joker' && i == 0" vertical :percent="1">
          <span>JK</span>
          <span class="index" :style="{ top: 82 + '%', color: '#000000' }">0</span>
        </Progress>
      </span>
      <span v-for="(i, card) in stat.totalColor">
        <Progress
          v-if="card == 'R'"
          vertical
          :class="card"
          :percent="i * 1.6"
          stroke-color="#FF1919"
        >
          <span>{{ card }}</span>
          <span class="index" :style="{ top: 100 - i * 1.6 + 2 + '%' }">
            {{
            i
            }}
          </span>
        </Progress>
      </span>
      <span v-for="(i, card) in stat.totalColor">
        <Progress
          v-if="card == 'B'"
          vertical
          :class="card"
          :percent="i * 1.6"
          stroke-color="#1C1A1A"
        >
          <span>{{ card }}</span>
          <span class="index" :style="{ top: 100 - i * 1.6 + 2 + '%' }">
            {{
            i
            }}
          </span>
        </Progress>
      </span>
    </div>
  </div>
</template>
<script>
import { Progress } from "iview";
import { watch } from "fs";

export default {
  props: ["stat"],
  components: {
    Progress
  },
  data() {
    return {
      newArr: {},
      boxShadow: {
        "box-shadow":
          "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
      }
    };
  }
};
</script>

<style lang="scss">
.ivu-progress-inner {
  background-color: #e2e7f0 !important;
}

.ivu-progress-vertical {
  width: 6.6% !important;
}

span.index {
  position: absolute;
  text-align: center;
  font-weight: bold;
  color: #ffffff;
  top: 0px;
  left: 0px;
  width: 100%;
}

.ivu-progress-bg {
  margin: 0 5% !important;
  width: 90% !important;
  border-radius: 0px !important;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 10px 0 rgba(0, 0, 0, 0.1);
}

.ivu-progress.ivu-progress-normal.ivu-progress-show-info.ivu-progress-vertical {
  text-align: center;
}

.ivu-progress-text {
  margin: 0 !important;
  text-align: center !important;
  font-weight: bold;
}

.ivu-tabs {
  overflow: visible !important;
}

.ivu-progress-show-info .ivu-progress-outer {
  padding-right: 0 !important;
  margin-right: 0 !important;
}

.hi-lo-history-tabs.ivu-tabs.ivu-tabs-tabpane {
  margin-top: 10px;
}

.ivu-progress-text {
  font-weight: bold;
}

.ivu-progress-vertical .ivu-progress-outer {
  width: 100% !important;
}

.ivu-progress-vertical .ivu-progress-inner {
  width: 100% !important;
}
</style>
